/*引用vue和vuex*/
import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
Vue.use(Vuex);

/*设置state参数*/
const state = {
  //页面头部显示
  showHeader: true,
};
// 操作数据
const mutations = {
  setShowHeader(state, str) {
    state.showHeader = str;
  },

};
//
const getters = {
  showHeader: state => state.showHeader,

};
//
const actions = {
  setShowHeader(context, payload) {
    context.commit("setShowHeader", payload);
  },
};
const store = new Vuex.Store({
  state: state,
  mutations: mutations,
  getters: getters,
  actions: actions,
  plugins: [
    createPersistedState({
      storage: window.sessionStorage
      // reducer(val){
      //   return {
      //     assessmentData: val.assessmentData
      //   }
      // }
    })
  ]
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js